interface Props {
    className: string;
    onClick?: any;
    title?: string;
}
export default function emfRefreshIcon({ className, onClick, title }: Props) {
    return (
        <svg onClick={onClick} className={className} xmlns="http://www.w3.org/2000/svg" width="13.544" height="14.004" viewBox="0 0 13.544 14.544">
            <title>{title}</title>
            <g id="Group_185381" data-name="Group 185381" transform="translate(-792 -1138.262)">
                <g id="Group_184884" data-name="Group 184884" transform="translate(792 1138.262)">
                    <g id="Group_3759" data-name="Group 3759">
                        <g id="Group_3758" data-name="Group 3758">
                            <path id="Path_2229" data-name="Path 2229" d="M1657.537-14218.148a6.784,6.784,0,0,0-4.719,1.9v-1.9a.519.519,0,0,0-.52-.518.518.518,0,0,0-.52.518v3.112a.52.52,0,0,0,.356.493l3.121,1.037a.522.522,0,0,0,.659-.329.52.52,0,0,0-.33-.657l-2.3-.764a5.71,5.71,0,0,1,8.052-.343,5.671,5.671,0,0,1,.344,8.028,5.712,5.712,0,0,1-8.053.344,5.676,5.676,0,0,1-1.765-5.129.519.519,0,0,0-.421-.6.52.52,0,0,0-.6.42l0,.01a6.82,6.82,0,0,0-.094,1.124,6.761,6.761,0,0,0,6.763,6.742,6.751,6.751,0,0,0,6.781-6.725A6.753,6.753,0,0,0,1657.537-14218.148Z" transform="translate(-1650.737 14218.666)" fill="currentColor" />
                        </g>
                    </g>
                </g>
            </g>
        </svg>

    )
}